import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 13.036 12.705",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "arrow-left",
		"data-name": "arrow-left",
		d: "M5.542,3.5l.646-.646a.7.7,0,0,1,.986,0l5.656,5.653a.7.7,0,0,1,0,.986L7.175,15.148a.7.7,0,0,1-.986,0L5.542,14.5a.7.7,0,0,1,.012-1l3.506-3.34H.7a.7.7,0,0,1-.7-.7V8.534a.7.7,0,0,1,.7-.7H9.06L5.554,4.5A.694.694,0,0,1,5.542,3.5Z",
		transform: "translate(13.036 15.353) rotate(180)",
		fill: "currentColor"
	})
});
export default SvgArrowLeft;
